import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { RadialGradient } from '@jouzen/ecom-components/v3/RadialGradient';

import AccoladeCard from './AccoladeCard';

const WhyOuraAccolades = () => {
  return (
    <section
      className="relative bg-sandstone-200 py-16 md:bg-sandstone-100"
      data-cy="why-oura-accolades"
    >
      <div className="md:hidden">
        <RadialGradient
          hex="#E7DDD1"
          id="gray"
          opacity={1}
          size={100}
          shape="circle"
          position={[50, 70]}
        />
      </div>
      <div className="hidden md:block">
        <RadialGradient
          hex="#E7DDD1"
          id="gray"
          opacity={1}
          size={70}
          shape="circle"
          position={[20, 50]}
        />
      </div>
      <LayoutGrid>
        <GridItem
          className="flex flex-col gap-6 md:flex-row"
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
        >
          <AccoladeCard
            heading="best_sleep_tracker"
            image={{
              localizedAlt: 'membership_women_health_card_tag',
              src: 'blue-sky/why-oura/womens-health-logo',
            }}
            year="2024"
          />
          <AccoladeCard
            heading="cnbc_disruptor_list"
            image={{
              localizedAlt: 'home_awards_cnbc',
              src: 'blue-sky/why-oura/cnbc-disruptor-logo',
            }}
            year="2024"
          />
          <AccoladeCard
            contentClass="pb-6 md:pb-8"
            heading="best_app_health_wellness"
            image={{
              localizedAlt: 'home_awards_webby',
              src: 'blue-sky/why-oura/webby-awards2-logo',
              width: 127,
              height: 74,
            }}
            logoClass="pb-0"
            year="2023"
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default WhyOuraAccolades;
